<template>
  <v-card>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subheading">{{ title }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line="single-line"
        hide-details="hide-details"
        clearable="clearable"
      ></v-text-field>
      <v-btn v-if="showCreateBtn" color="teal" dark="dark" small="small" fab="fab" @click="add">
        <v-icon>add</v-icon>
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      item-key="id"
      :items="leads"
      :search="search"
      :pagination.sync="pagination"
      ><template slot="items" slot-scope="props"
        ><tr class="pointer" @click="gotoPage(props.item)">

          <td class="text-xs-left" >{{ props.item.createdAt | moment('LL')}}</td>

          <td class="text-xs-left">
            <StatusIndicator
              class="mr-2"
              negative="negative"
              pulse="pulse"
              v-if="$moment(props.item.dueDate).format('MM/DD/YYY 23:59:59') > $moment().format('MM/DD/YYYY 23:59:59')"
            ></StatusIndicator
            ><span v-html="$options.filters.highlight(props.item.assignedToUser.fullName, search)">{{ props.item.assignedToUser.fullName }}</span>
          </td>
          <td class="text-xs-left" v-html="$options.filters.highlight(props.item.firstName, search)">{{ props.item.firstName }}</td>
          <td class="text-xs-left" v-html="$options.filters.highlight(props.item.phoneNumber, search)">{{ props.item.phoneNumber }}</td>
          <td class="text-xs-left" >{{ $moment(props.item.dueDate).format("MM/DD h:mm a") }}</td>
        </tr></template
      >
      <v-alert slot="no-results" :value="true" color="error" icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert
      >
    </v-data-table>
  </v-card>
</template>

<script>
// import Create from './Create'
import { StatusIndicator } from "vue-status-indicator";
// import "vue-status-indicator/styles.css";

export default {
  props: {
    title: {
      type: String,
      default: "Leads"
    },
    leads: {
      type: Array,
      default: []
    },
    showCreateBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      createDialog: false,
      expand: false,
      headers: [
        {
          text: this.$t("labels.createdAt"),
          value: "assignedToUser.createdAt",
          sortable: true
        },
        {
          text: this.$t("labels.user"),
          value: "assignedToUser.fullName",
          sortable: true
        },
        {
          text: this.$t("labels.firstName"),
          value: "firstName",
          sortable: true
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "phoneNumber",
          sortable: true
        },
        {
          text: this.$t("labels.dueDate"),
          value: "dueDate",
          sortable: true
        }
      ],
      search: null,
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "id",
        descending: true
      }
    };
  },
  components: {
    StatusIndicator
  },
  methods: {
    gotoPage(data) {
      this.$router.push({ path: `/leads/profile/${data.id}` });
    },
    gotoPageNewTab(data) {
      let routeData = this.$router.resolve({ path: `/leads/profile/${data.id}` });
      window.open(routeData.href, "_blank");
    },
    add() {
      this.createDialog = true;
    }
  }
};
</script>

<style scoped></style>
